// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/export_template.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from message omnios.v1.ExportTemplate
 */
export const ExportTemplate = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExportTemplate",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "format", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "columns", kind: "message", T: Struct },
    { no: 10, name: "header_config", kind: "message", T: Struct },
    { no: 11, name: "footer_config", kind: "message", T: Struct },
    { no: 12, name: "styling", kind: "message", T: Struct },
    { no: 13, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "content_filter", kind: "message", T: Struct },
    { no: 15, name: "image_normalize", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "created_at", kind: "message", T: Timestamp },
    { no: 21, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ExportColumn
 */
export const ExportColumn = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExportColumn",
  () => [
    { no: 1, name: "field", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "header", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "number_format", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateExportTemplateRequest
 */
export const CreateExportTemplateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateExportTemplateRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "format", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "columns", kind: "message", T: Struct },
    { no: 8, name: "header_config", kind: "message", T: Struct },
    { no: 9, name: "footer_config", kind: "message", T: Struct },
    { no: 10, name: "styling", kind: "message", T: Struct },
    { no: 11, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "content_filter", kind: "message", T: Struct },
    { no: 13, name: "image_normalize", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.GetExportTemplateRequest
 */
export const GetExportTemplateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetExportTemplateRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateExportTemplateRequest
 */
export const UpdateExportTemplateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateExportTemplateRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "format", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "columns", kind: "message", T: Struct },
    { no: 6, name: "header_config", kind: "message", T: Struct },
    { no: 7, name: "footer_config", kind: "message", T: Struct },
    { no: 8, name: "styling", kind: "message", T: Struct },
    { no: 9, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 10, name: "content_filter", kind: "message", T: Struct },
    { no: 11, name: "image_normalize", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteExportTemplateRequest
 */
export const DeleteExportTemplateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteExportTemplateRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListExportTemplatesRequest
 */
export const ListExportTemplatesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListExportTemplatesRequest",
  () => [
    { no: 1, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListExportTemplatesResponse
 */
export const ListExportTemplatesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListExportTemplatesResponse",
  () => [
    { no: 1, name: "templates", kind: "message", T: ExportTemplate, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.ExportOrderRequest
 */
export const ExportOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExportOrderRequest",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ExportOrderResponse
 */
export const ExportOrderResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExportOrderResponse",
  () => [
    { no: 1, name: "file_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Generate a client-ready price list / proposal directly from the catalog,
 * without going through an order. Applies the customer's preferences (markup,
 * brand/category rules, price band) and the template's content_filter.
 * filter_overrides override the template's content_filter for this run.
 *
 * @generated from message omnios.v1.ExportClientCatalogRequest
 */
export const ExportClientCatalogRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExportClientCatalogRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filter_overrides", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.ExportClientCatalogResponse
 */
export const ExportClientCatalogResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExportClientCatalogResponse",
  () => [
    { no: 1, name: "file_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "product_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.PreviewExportTemplateRequest
 */
export const PreviewExportTemplateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PreviewExportTemplateRequest",
  () => [
    { no: 1, name: "template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PreviewExportTemplateResponse
 */
export const PreviewExportTemplateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PreviewExportTemplateResponse",
  () => [
    { no: 1, name: "headers", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "rows", kind: "message", T: Struct, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetDefaultExportColumnsRequest
 */
export const GetDefaultExportColumnsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetDefaultExportColumnsRequest",
  [],
);

/**
 * @generated from message omnios.v1.GetDefaultExportColumnsResponse
 */
export const GetDefaultExportColumnsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetDefaultExportColumnsResponse",
  () => [
    { no: 1, name: "columns", kind: "message", T: ExportColumn, repeated: true },
  ],
);

/**
 * Parse a previously-uploaded XLSX/CSV file (referenced by
 * media_id) and infer template columns from its header
 * row. Used by the template editor's "Загрузить из файла"
 * button so a sales user can hand a customer's existing
 * price-list to Omnicom and have the template populated.
 *
 * @generated from message omnios.v1.ParseTemplateFromMediaRequest
 */
export const ParseTemplateFromMediaRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ParseTemplateFromMediaRequest",
  () => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ParseTemplateFromMediaResponse
 */
export const ParseTemplateFromMediaResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ParseTemplateFromMediaResponse",
  () => [
    { no: 1, name: "columns", kind: "message", T: ExportColumn, repeated: true },
    { no: 2, name: "detected_format", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "column_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

